import { Injectable } from "@angular/core";
import { PushNotificationApiResponse } from "src/app/shared/models/model";

@Injectable({
  providedIn: "root",
})
export class CommonDataShareService {
  private pushNotificationTemplateData: any = null;

  // Setter method
  setPushNotificationTemplateData(data: any): void {
    this.pushNotificationTemplateData = data;
  }

  // Getter method
  getPushNotificationTemplateData(): PushNotificationApiResponse {
    return this.pushNotificationTemplateData;
  }

  // Reset method
  resetPushNotificationTemplateData(): void {
    this.pushNotificationTemplateData = null;
  }
}
